/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {AdvertiserAddDto} from '../models/AdvertiserAddDto'
import type {AdvertiserDtoSuccessDataResult} from '../models/AdvertiserDtoSuccessDataResult'
import type {AdvertiserEditDto} from '../models/AdvertiserEditDto'

import type {CancelablePromise} from '../core/CancelablePromise'
import {OpenAPICouponCenter} from 'rest'
import {request as __request} from '../core/request'

export class AdvertiserService {
  /**
   * @param requestBody
   * @returns AdvertiserDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static postApiAdvertiserAdd(
    requestBody?: AdvertiserAddDto
  ): CancelablePromise<AdvertiserDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'POST',
      url: '/api/Advertiser/Add',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param requestBody
   * @returns AdvertiserDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static putApiAdvertiserEdit(
    requestBody?: AdvertiserEditDto
  ): CancelablePromise<AdvertiserDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'PUT',
      url: '/api/Advertiser/Edit',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param advertiserId
   * @returns AdvertiserDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiAdvertiserGet(
    advertiserId?: number
  ): CancelablePromise<AdvertiserDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Advertiser/Get',
      query: {
        advertiserId: advertiserId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param sourceId
   * @returns AdvertiserDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiAdvertiserGetBySourceId(
    sourceId?: number
  ): CancelablePromise<AdvertiserDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Advertiser/GetBySourceId',
      query: {
        sourceId: sourceId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
}
